import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-property-scene-desktop',
  templateUrl: './property-scene-desktop.component.html',
  styleUrls: ['./property-scene-desktop.component.scss'],
  standalone: false
})
export class PropertySceneDesktopComponent {
  @Input()
  isIndicateurRisqueMoyenHaut = false;

  constructor() {}
}
